import React from 'react';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import ShootsListTableRow from '../../components/shootListTableRow';
import { ReactComponent as PendingIcon } from '../../../assets/svg/pending.svg';
import { ReactComponent as Down } from '../../../assets/svg/down-arrow-search.svg';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import _, { times } from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import NotifyShootCrew from '../../components/modals/shoots/notifyCrew';
import { gql } from '@apollo/client';
import InfiniteScroll from 'react-infinite-scroll-component';
import CreateShoot from '../../components/modals/projects/createShoot';
import Modal from '../../components/modals';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import Select, { components } from 'react-select';
import service from '../../../services/graphQlServices';
import constants from '../../../utils/constants';

const notifyTeamMembers = gql`
	mutation NotifyShootCrew(
		$workspaceId: String!
		$projectId: ID!
		$eventId: ID!
		$crewPhNumber: [String!]
	) {
		notifyShootCrew(
			workspaceId: $workspaceId
			projectId: $projectId
			eventId: $eventId
			crewPhNumber: $crewPhNumber
		) {
			message
		}
	}
`;

const getEventsCitiesList = gql`
	query VendorEventsList {
		eventsCityList
	}
`;

const getVendorEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput, $vendorId: String!) {
		vendorEventsList(filters: $filters) {
			data {
				id
				tenantId
				projectId
				name
				slNo
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
				city
				venue
				date
				time
				reportingTime
				dateOverlap
				dateTimeOverlap
				parentEvent_id
				projectTitle
				parentEventName
				childEvents {
					_id
					name
				}
				memoryCards {
					status
					isReceived
				}
				equipments {
					isReceived
					status
				}
				additionalServices {
					type
					_id
				}

				feedBack {
					_id
					files {
						_id
						originalFileName
					}
				}
				unregisteredEqs {
					quantity
					receivedQuantity
				}
				outStation
				collaborators {
					designations
					isManager
					tenantUserId
				}
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
			isSuperHuemn
		}
		vendorUsers {
			lastName
			firstName
			id
			displayName
			phoneNumber
		}
	}
`;

const getOnlyVendorEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput) {
		vendorEventsList(filters: $filters) {
			data {
				id
				tenantId
				projectId
				name
				slNo
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
				city
				venue
				date
				time
				reportingTime
				dateOverlap
				dateTimeOverlap
				parentEvent_id
				projectTitle
				parentEventName
				childEvents {
					_id
					name
				}
				memoryCards {
					status
					isReceived
				}
				equipments {
					isReceived
					status
				}
				additionalServices {
					type
					_id
				}
				feedBack {
					_id
					files {
						_id
						originalFileName
					}
				}
				unregisteredEqs {
					quantity
					receivedQuantity
				}
				outStation
				collaborators {
					designations
					isManager
					tenantUserId
				}
			}
			totalPages
			currentPage
			hasNextPage
		}
	}
`;

const getProjects = gql`
	query VendorsProjects($workspaceIds: [String!], $filters: projectsListFiltersInput) {
		vendorsProjects(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				id
				title
			}
		}
	}
`;

const updateShoot = gql`
	mutation UpdateEvent(
		$projectId: ID!
		$eventId: ID!
		$eventInput: EventInput!
		$workspaceId: String!
	) {
		updateEvent(
			projectId: $projectId
			eventId: $eventId
			eventInput: $eventInput
			workspaceId: $workspaceId
		) {
			id
			tenantId
			projectId
			name
			slNo
			crew {
				count
				role
				managerIds
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			city
			venue
			date
			time
			reportingTime
			dateOverlap
			dateTimeOverlap
			parentEvent_id
			projectTitle
			parentEventName
			childEvents {
				_id
				name
			}
			memoryCards {
				status
				isReceived
			}
			equipments {
				isReceived
				status
			}
			additionalServices {
				type
				_id
			}
			feedBack {
				_id
				files {
					_id
					originalFileName
				}
			}
			unregisteredEqs {
				quantity
				receivedQuantity
			}
		}
	}
`;

class Shoots extends ProjectsGraphQlController {
	constructor() {
		super();
		this.calRef = React.createRef(null);
		this.calRef2 = React.createRef(null);
		this.state = {
			isLoading: true,
			limit: 30,
			page: 1,
			searchQuery: '',
			myDates: {},
			sortBy: '',
			sortType: 0,
			currentViewPage: 1,
			startDate: null,
			endDate: null,
			startDateVal: null,
			endDateVal: null,
			startEndDateSet: false,
			prevStatus: null,
			isPageLoading: false,
			totalPages: 1,
			lengthOfList: 0,
			shootList: [],
			associatedTenants: [],
			ownerIdActiveFilter: 'createdAt',
			tenantUsersList: {},
			showCustomDate: false,

			workspaceActiveFilter: [],
			workspaceFilterCleared: false,
			workspacesFilters: [],
			cityFilters: [],
			workspacesOptions: [],
			columns: [
				// { title: 'FLAG' },
				{ title: 'TIME' },
				{ title: 'CITY/VENUE' },
				{ title: 'SHOOT ID' },
				{ title: 'SHOOT' },
				{ title: 'CP' },
				{ title: 'TP' },
				{ title: 'CV' },
				{ title: 'TV' },
				{ title: 'EQ' },
				{ title: 'MC' },
				{ title: 'ADD SERVICES' },
				{ title: 'FEEDBACK' },
				{ title: 'HEADS' },
			],
			statusFilters: [
				{ key: 'all', name: 'All' },
				{ key: 'upcoming', name: 'Upcoming Shoots' },
				{ key: 'today', name: 'Today' },
				{ key: 'completed', name: 'Completed Shoots' },
				{ key: 'unreturnedEq', name: 'Unreturned EQ' },
				{ key: 'unreturnedMC', name: 'Unreturned MC' },
				{ key: null, name: 'Custom Date' },
			],

			projectActiveFilter: '',
			statusActiveFilter: '',
			showSearchDropDown: false,
			showWorkspaceDropDown: false,
			projectFilters: [],
			shootersActiveFilter: [],
			cityActiveFilter: [],
			showEquipmentStatus: '',
			showMCStatus: '',
			searchType: 'projectTitle',
			hasNextPage: true,
			currStatus: 'all',
			cityActiveFilter: '',
			projectTitleActiveFilter: '',

			showShootAddEditModal: false,
			eventDetails: {},
			showCreateShootModal: false,
			createShootWorkspace: null,
			createShootWorkspaceName: null,
			projectsOptions: [],
			createShootProject: null,
			isProjectsLoading: false,

			isCrewCopied: false,
			copiedCrew: [],
			showNotifyTeamMemberModal: false,
			ignoreCrew: ['63f24102cbcc7529d8bd4257', '63f2413ba462f3bc033580b5'],
			notifyDetails: {},
			tenantUsersOGList: {},
			shootEditType: null,
			showDuplicateCrewWithRoleWarning: false,
			duplicateCrewWithRole: [],
			backwardPage: 0,
			hasMorePast: true,
			loadingPast: false,
		};

		this.searchDropDownRef = React.createRef();
		this.wrapper = React.createRef();
		this.workspaceDropDownRef = React.createRef();
		this.workspacewrapper = React.createRef();
		this.scrollContainerRef = React.createRef();
		this._isPrepending = false;
		this.scrollThrottleRef = null;
	}

	getActiveWorkspaceFilter = () => {
		// If user has selected specific workspaces, use those
		if (_.size(this.state.workspaceActiveFilter) > 0) {
			return this.state.workspaceActiveFilter;
		}
		// If user explicitly cleared the workspace filter, return null to fetch all data
		if (this.state.workspaceFilterCleared) return null;
		// Otherwise use vendor's activeWorkspaces from constants (extract _id)
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			return vendorConfig.activeWorkspaces.map(w => w._id);
		}
		return null;
	};

	componentDidMount = () => {
		// Pre-select active workspaces from constants (extract _id for filter keys)
		const vendorConfig = constants.userAccess.vendors?.[this.props.params.vendorID];
		if (vendorConfig?.activeWorkspaces?.length > 0) {
			this.setState({ workspaceActiveFilter: vendorConfig.activeWorkspaces.map(w => w._id) });
		}
		this.getVendorShootListData();
		document.addEventListener('mousedown', this.handleClickOutside);
	};

	handleCityFilterOpen = () => {
		if (this.state.cityFilters.length === 0 && !this.state.isCityListLoading) {
			this.setState({ isCityListLoading: true }, async () => {
				await this.getEventsCitiesList(getEventsCitiesList);
				this.setState({ isCityListLoading: false });
			});
		}
	};

	getSnapshotBeforeUpdate(prevProps, prevState) {
		if (this._isPrepending && this.scrollContainerRef.current) {
			const scrollTop = this.scrollContainerRef.current.scrollTop;
			// Only restore scroll if user is NOT at the top
			if (scrollTop > 10) {
				return {
					scrollHeight: this.scrollContainerRef.current.scrollHeight,
					scrollTop,
				};
			}
		}
		return null;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this._isPrepending) {
			if (snapshot && this.scrollContainerRef.current) {
				const heightDiff = this.scrollContainerRef.current.scrollHeight - snapshot.scrollHeight;
				if (heightDiff > 0) {
					this.scrollContainerRef.current.scrollTop = snapshot.scrollTop + heightDiff;
				}
			}
			this._isPrepending = false;
		}
	}

	handleShootsWheel = (e) => {
		if (this.state.loadingPast || !this.state.hasMorePast) return;
		if (this.state.currStatus !== 'all') return;
		if (e.deltaY >= 0) return; // only trigger on scroll up
		if (!this.scrollContainerRef.current) return;
		if (this.scrollContainerRef.current.scrollTop > 50) return;
		if (this.scrollThrottleRef) return;

		this.scrollThrottleRef = setTimeout(() => {
			this.scrollThrottleRef = null;
		}, 500);

		this.fetchPastShoots();
	};

	processPastEvents = (rawEvents) => {
		const tenantUsersList = Array.isArray(this.state.tenantUsersOGList)
			? this.state.tenantUsersOGList
			: [];
		let processed = [];
		_.forEach(rawEvents, (event) => {
			let tempEvent = { ...event, crewDetails: [], crewNew: [] };
			_.forEach(event.crewNew, (crew) => {
				if (crew.isCustomUser === false) {
					_.forEach(crew.roles, (roles) => {
						let found = crew.userId
							? _.find(tenantUsersList, { id: crew.userId })
							: undefined;
						let data = {
							name: found
								? `${found.firstName || ''} ${found.lastName || ''}`
								: crew.userId === null
								? 'unassigned'
								: 'User unknown',
							dateOverlap: false,
							dateTimeOverlap: false,
							isManager: crew.isManager || false,
							role: roles.role,
							subRole: roles.subRole,
							displayName: found?.displayName || (crew.userId === null ? 'unassigned' : 'User unknown'),
							id: crew.userId,
						};
						tempEvent.crewDetails.push(data);
					});
					tempEvent.crewNew.push(crew);
				}
			});
			processed.push(tempEvent);
		});
		return processed;
	};

	fetchPastShoots = async () => {
		if (this.state.loadingPast || !this.state.hasMorePast) return;

		this.setState({ loadingPast: true });

		const usertoken = localStorage.getItem('usertoken');
		const vendorID = this.props.params.vendorID;
		let currentPage = this.state.backwardPage;
		let allEvents = [];
		let hasMore = true;
		let boundaryDate = null;

		try {
			// Fetch pages until the boundary date is complete
			while (hasMore) {
				currentPage++;
				const variables = {
					filters: {
						page: currentPage,
						limit: this.state.limit,
						sortType: -1,
						sortBy: 'date',
						subFilter: 'completed',
					},
				};

				const wsFilter = this.getActiveWorkspaceFilter();
				if (wsFilter) variables.filters.wsTenantIds = wsFilter;
				if (_.size(this.state.cityActiveFilter) > 0)
					variables.filters.city = this.state.cityActiveFilter;
				if (_.size(this.state.shootersActiveFilter) > 0)
					variables.filters.shooters = this.state.shootersActiveFilter;

				const response = await service.query(
					getOnlyVendorEventsList,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);

				if (response[0] !== true) {
					hasMore = false;
					break;
				}

				const pageData = response[1].data.vendorEventsList;
				const processed = this.processPastEvents(pageData.data);

				if (boundaryDate === null) {
					// First page — take all events
					allEvents = allEvents.concat(processed);
					if (processed.length > 0) {
						boundaryDate = processed[processed.length - 1].date;
					}
				} else {
					// Continuation pages — only take events from the boundary date
					const matching = processed.filter((e) => e.date === boundaryDate);
					allEvents = allEvents.concat(matching);
					if (matching.length < processed.length) {
						// Found events from a different (older) date — boundary date is complete
						hasMore = false;
					}
				}

				if (!pageData.hasNextPage || processed.length === 0) {
					hasMore = false;
				}

				// Update backwardPage so next trigger starts from the right page
				this.setState({ backwardPage: currentPage });

				// Check if the API has more pages
				if (!pageData.hasNextPage) {
					this.setState({ hasMorePast: false });
					hasMore = false;
				}
			}

			// Reverse so oldest is first (timeline order)
			allEvents.reverse();

			// Deduplicate — remove events already in the list
			const existingIds = new Set(this.state.shootList.map((s) => s.id));
			allEvents = allEvents.filter((e) => !existingIds.has(e.id));

			if (allEvents.length > 0) {
				this._isPrepending = true;
			}
			this.setState(
				{
					shootList: [...allEvents, ...this.state.shootList],
					loadingPast: false,
				},
				() => {
					if (_.has(this, 'flagShootersForTheSameDay'))
						this.flagShootersForTheSameDay();
				},
			);
		} catch (err) {
			this.setState({ loadingPast: false });
		}
	};

	handleContextMenu = (e) => {
		e.preventDefault();
	};
	getVendorShootListData = async () => {
		let json = {};
		let urlSearch =
			_.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];

		if (_.size(urlSearch) > 0) {
			let count = 0;
			let tempCount = 0;
			let searchType = null;
			let tempUrlSearch = _.cloneDeep(urlSearch);
			while (tempCount < _.size(tempUrlSearch)) {
				let subString = tempUrlSearch[tempCount].split('=');

				if (subString[0] && subString[0] === 'searchType') {
					searchType = subString[1];
				}
				tempCount++;
			}
			json = {
				filters: {
					//page: this.state.currStatus === 'upcoming' ? 1 : -1,
					limit: this.state.limit,
					sortType: 1,
				},
				vendorId: this.props.params.vendorID,
			};
			while (count < _.size(urlSearch)) {
				let subString = urlSearch[count].split('=');
				if (subString[0] === 'startDate') {
					json = {
						...json,
						filters: {
							...json.filters,
							startDate: parseInt(subString[1]),
						},
					};
				}
				if (subString[0] === 'endDate') {
					json = {
						...json,
						filters: {
							...json.filters,
							endDate: parseInt(subString[1]),
						},
					};
				}

				if (subString[0] && subString[0] !== 'limit' && subString[0] !== 'searchType') {
					json = {
						...json,
						filters: {
							...json.filters,

							sortType:
								subString[0] === 'subFilter' && subString[1] === 'completed'
									? -1
									: 1,
							limit: this.state.limit,
							[`${
								subString[0] === 'subFilter'
									? subString[1] === 'unreturnedEq' ||
									  subString[1] === 'unreturnedMC'
										? subString[1] === 'unreturnedEq'
											? 'unreturnedEq'
											: 'unreturnedMc'
										: 'subFilter'
									: subString[0] === 'search'
									? searchType
									: subString[0]
							}`]:
								subString[0] !== 'startDate' && subString[0] !== 'endDate'
									? subString[0] === 'subFilter'
										? subString[1] === 'unreturnedEq' ||
										  subString[1] === 'unreturnedMC'
											? true
											: subString[1] === 'null'
											? null
											: subString[1] === 'all'
											? 'upcoming'
											: subString[1]
										: subString[0] === 'page'
										? parseInt(subString[1].split(',')[0])
										: subString[0] === 'search'
										? new URLSearchParams(urlSearch[count]).get('search')
										: subString[0] === 'city'
										? new URLSearchParams(urlSearch[count])
												.get('city')
												.split(',')
										: subString[1].split(',')
									: parseInt(subString[1]),
						},
						vendorId: this.props.params.vendorID,
					};
					if (
						subString[0] === 'subFilter' &&
						(subString[1] === 'unreturnedMC' || subString[1] === 'unreturnedEq')
					) {
						json = {
							...json,
							filters: {
								...json.filters,
								sortBy: 'date',
								sortType: -1,
							},
						};
					}

					if (subString[0] === 'subFilter' && subString[1] === 'null') {
						this.setState({
							showCustomDate: true,
						});
					}
					if (subString[0] === 'search') {
						this.setState({
							searchType,
						});
					}

					this.setState({
						[`${
							subString[0] === 'subFilter'
								? 'currStatus'
								: subString[0] === 'wsTenantIds'
								? 'workspaceActiveFilter'
								: subString[0] === 'search'
								? `${searchType}ActiveFilter`
								: `${subString[0]}ActiveFilter`
						}`]:
							subString[0] === 'subFilter'
								? subString[1] === 'null'
									? null
									: subString[1]
								: subString[0] === 'search'
								? new URLSearchParams(urlSearch[count]).get('search')
								: subString[0] === 'city'
								? new URLSearchParams(urlSearch[count]).get('city').split(',')
								: subString[1].split(','),
					});
					if (
						this.state.showCustomDate &&
						(subString[0] === 'startDate' || subString[0] === 'endDate')
					) {
						this.setState({
							[subString[0]]: moment(subString[1]).local().toDate(),
						});
					}
				}

				count++;
			}
			// Apply active workspaces filter if no workspace filter from URL
			if (!json.filters.wsTenantIds) {
				const wsFilter = this.getActiveWorkspaceFilter();
				if (wsFilter) json.filters.wsTenantIds = wsFilter;
			}

			let pages = json.filters.page;

			if (pages && pages > 1) {
				for (let i = 1; i <= pages; i++) {
					let newJson;
					newJson = {
						...json,
						filters: {
							...json.filters,
							page: i,
						},
						vendorId: json.vendorId,
					};

					await this.getVendorEventsList(
						i == 1 ? getVendorEventsList : getOnlyVendorEventsList,
						newJson,
						true,
						pages,
					);
				}
			} else {
				await this.getVendorEventsList(getVendorEventsList, json);
			}
		} else {
			json = {
				filters: {
					page: 1,
					limit: this.state.limit,
					sortType: 1,
					sortBy: 'date',
					subFilter: 'upcoming',
				},
				vendorId: this.props.params.vendorID,
			};
			const wsFilter = this.getActiveWorkspaceFilter();
			if (wsFilter) json.filters.wsTenantIds = wsFilter;
			await this.getVendorEventsList(getVendorEventsList, json);
		}
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
		if (this.scrollThrottleRef) clearTimeout(this.scrollThrottleRef);
	}

	handleClickOutside = (event) => {
		if (
			this.searchDropDownRef.current &&
			!this.searchDropDownRef.current.contains(event.target) &&
			this.wrapper.current &&
			!this.wrapper.current.contains(event.target)
		) {
			this.setState({
				showSearchDropDown: false,
			});
		}

		if (
			this.workspaceDropDownRef.current &&
			!this.workspaceDropDownRef.current.contains(event.target) &&
			this.workspacewrapper.current &&
			!this.workspacewrapper.current.contains(event.target)
		) {
			this.setState({
				showWorkspaceDropDown: false,
			});
		}
	};

	toggleSearchDropDown = () => {
		this.setState({
			showSearchDropDown: !this.state.showSearchDropDown,
		});
	};

	toggleWorkspaceDropDown = () => {
		this.setState({
			showWorkspaceDropDown: !this.state.showWorkspaceDropDown,
		});
	};

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
				},
				async () => {
					await this.fetchMoreShoots();
				},
			);
		}
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreShoots();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreShoots();
				},
			);
		}
	};

	flagShootersForTheSameDay = () => {
		let shootList = this.state.shootList;

		_.map(shootList, (shoot, key) => {
			_.map(shoot.crewDetails, (crew, crewIndex) => {
				if (_.indexOf(this.state.ignoreCrew, crew.id) == -1 && crew.id !== null) {
					let sameCrewIndex = _.size(
						_.filter(shoot.crewDetails, {
							id: crew.id,
						}),
					);

					if (sameCrewIndex > 1) {
						shootList[key]['crewDetails'][crewIndex]['dateOverlap'] = true;
						shootList[key]['crewDetails'][crewIndex]['dateTimeOverlap'] = true;
					}

					_.map(this.state.shootList, (shootNew, keyNew) => {
						if (shootNew.date === shoot.date && shootNew.id !== shoot.id) {
							let index = _.findIndex(shootNew.crewDetails, {
								id: crew.id,
							});

							if (index >= 0) {
								shootList[keyNew]['crewDetails'][index]['dateOverlap'] = true;

								if (
									shoot['reportingTime'] != null &&
									shoot['reportingTime'] != '' &&
									shootNew['reportingTime'] != null &&
									shootNew['reportingTime'] != '' &&
									shoot['reportingTime'].trim().split(' ')[1] ===
										shootNew['reportingTime'].trim().split(' ')[1]
								) {
									shootList[keyNew]['crewDetails'][index][
										'dateTimeOverlap'
									] = true;
								}
							}
						}
					});
				}
			});
		});

		this.setState({ shootList });
	};

	fetchMoreShoots = async () => {
		let urlSearch =
			window.location.search.split('?') && _.size(window.location.search.split('?')) > 1
				? window.location.search.split('?')[1].split('&')
				: [];

		let subString = _.size(urlSearch) > 0 ? urlSearch[0].split('=') : null;

		if (
			(subString !== null &&
				this.state.currentViewPage > parseInt(subString[1].split(',')[0])) ||
			subString == null ||
			this.state.currentViewPage == 1
		) {
			let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;

			//Condition for workspace
			if (_.size(this.state.workspaceActiveFilter) > 0)
				queryString = `${queryString}&wsTenantIds=${this.state.workspaceActiveFilter.toString()}`;

			//Condition for shoot status
			if (_.size(this.state.currStatus) > 0) {
				queryString = `${queryString}&subFilter=${this.state.currStatus}`;
			}

			//Condition for shooters filter
			if (_.size(this.state.shootersActiveFilter) > 0) {
				queryString = `${queryString}&shooters=${this.state.shootersActiveFilter.toString()}`;
			}

			//Condition for city filter
			if (_.size(this.state.cityActiveFilter) > 0) {
				queryString = `${queryString}&city=${this.state.cityActiveFilter.toString()}`;
			}

			//Condition for Search String
			if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0)
				queryString = `${queryString}&search=${this.state[
					`${this.state.searchType}ActiveFilter`
				].trim()}&searchType=${this.state.searchType}`;
			if (this.state.currStatus === null) {
				queryString = `${queryString}&subFilter=${this.state.currStatus}`;
			}
			if (
				this.state.startDateVal !== null &&
				this.state.endDateVal !== null &&
				this.state.currStatus == null
			) {
				queryString = `${queryString}&startDate=${this.state.startDateVal.toString()}&endDate=${this.state.endDateVal.toString()}`;
			}
			this.props.navigate(`/${this.props.params.vendorID}/shoots${queryString}`);

			let eventsListJson = {
				filters: {
					page: this.state.currentViewPage,
					limit: this.state.limit,
					sortType: this.state.currStatus === 'completed' ? -1 : 1,
				},
				vendorId: this.props.params.vendorID,
				vendorTenantUsersListFilters2: {
					page: 1,
					limit: 10000,
				},
			};

			if (_.size(this.state.shootersActiveFilter) > 0) {
				eventsListJson.filters.shooters = this.state.shootersActiveFilter;
			}
			// if (
			//     this.state.currStatus !== 'unreturnedEq' &&
			//     this.state.currStatus !== 'unreturnedMC' &&
			//     this.state.currStatus === 'customDate'
			// ) {
			//     eventsListJson.filters.subFilter = null
			// }
			if (
				this.state.currStatus !== 'unreturnedEq' &&
				this.state.currStatus !== 'unreturnedMC'
			) {
				eventsListJson.filters.subFilter = this.state.currStatus === 'all' ? 'upcoming' : this.state.currStatus;
				if (this.state.currStatus === null) {
					this.setState({
						showCustomDate: true,
					});
				} else if (this.state.currStatus !== null) {
					this.setState({
						showCustomDate: false,
					});
				}
			}
			if (this.state.currStatus !== null) {
				this.setState({
					showCustomDate: false,
				});
			}
			if (this.state.startDateVal !== null && this.state.endDateVal !== null) {
				eventsListJson.filters.startDate = this.state.startDateVal;
				eventsListJson.filters.endDate = this.state.endDateVal;
				if (this.state.startEndDateSet === false) {
					this.setState({
						shootList: [],
						startEndDateSet: true,
						backwardPage: 0,
						hasMorePast: true,
					});
				}
			}

			//Condition for Workspace
			const wsFilter = this.getActiveWorkspaceFilter();
			if (wsFilter) eventsListJson.filters.wsTenantIds = wsFilter;

			if (this.state.currStatus === 'unreturnedEq') {
				eventsListJson.filters.unreturnedEq = true;
				eventsListJson.filters.sortBy = 'date';
				eventsListJson.filters.sortType = -1;
			}

			if (this.state.currStatus === 'unreturnedMC') {
				eventsListJson.filters.unreturnedMc = true;
				eventsListJson.filters.sortBy = 'date';
				eventsListJson.filters.sortType = -1;
			}

			if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0) {
				eventsListJson.filters[this.state.searchType] =
					this.state[`${this.state.searchType}ActiveFilter`].trim();
			}

			if (_.size(this.state.cityActiveFilter) > 0)
				eventsListJson.filters.city = this.state.cityActiveFilter;

			this.getVendorEventsList(getOnlyVendorEventsList, eventsListJson);
		}
	};

	handleActiveFilter = (e, type, key) => {
		let array;
		if (type === 'project' || type === 'status') {
			array = this.state[`${type}ActiveFilter`] === key ? '' : key;
		} else {
			array = [...this.state[`${type}ActiveFilter`]];

			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
				backwardPage: 0,
				hasMorePast: true,
			},
			() => this.fetchMoreShoots(),
		);
	};

	goToShoot = (e, workspaceID, projectID, shootID, newTab = false) => {
		localStorage.setItem('lastViewedShootID', shootID);
		let workspace;
		workspace = _.filter(this.state.associatedTenants, {
			_id: workspaceID,
		})[0].workspaceId;
		if (workspace) {
			let url = `/${this.props.params.vendorID}/shoots/${workspace}/${projectID}/${shootID}`;
			if (newTab) {
				window.open(url);
			} else this.props.navigate(url);
		}
	};

	goToAssignReceiveEquipment = (workspaceID, projectID, shootID, type) => {
		let workspace;
		workspace = _.filter(this.state.associatedTenants, {
			_id: workspaceID,
		})[0].workspaceId;
		if (workspace) {
			this.props.navigate(
				`/${this.props.params.vendorID}/shoots/${workspace}/${projectID}/${shootID}/${type}-equipment`,
			);
		}
	};
	goToAssignReceiveMC = (workspaceID, projectID, shootID, type) => {
		let workspace;
		workspace = _.filter(this.state.associatedTenants, {
			_id: workspaceID,
		})[0].workspaceId;
		if (workspace) {
			this.props.navigate(
				`/${this.props.params.vendorID}/shoots/${workspace}/${projectID}/${shootID}/${type}-memory-card`,
			);
		}
	};

	onFlagSelected = (flagLabel, tenantId, projectId, eventId) => {
		let json = {
			projectId,
			eventId,
			eventInput: {
				flagLabel,
			},
			workspaceId: _.find(this.state.workspacesFilters, { key: tenantId })?.name,
		};

		this.updateShoot(updateShoot, json);
	};

	searchString = (e, type = null) => {
		if (type !== null) {
			this.setState({
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
				backwardPage: 0,
				hasMorePast: true,
			});
		} else {
			this.setState({
				[`${this.state.searchType}ActiveFilter`]: e.target.value,
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
				backwardPage: 0,
				hasMorePast: true,
			});
		}
		if (this.timeout) clearTimeout(this.timeout);
		this.timeout = setTimeout(async () => {
			this.fetchMoreShoots();
		}, 1000);
	};
	toggleSearchType = (e, type) => {
		let tempActiveFilter = this.state[`${this.state.searchType}ActiveFilter`];
		this.setState(
			{
				[`${this.state.searchType}ActiveFilter`]: '',
				[`${type}ActiveFilter`]: tempActiveFilter,
				searchType: type,
				showSearchDropDown: false,
				isPageLoading: _.size(tempActiveFilter.trim()) > 0,
			},
			() => {
				if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0) {
					this.setState({
						currentViewPage: 1,
					});
					this.fetchMoreShoots();
				}
			},
		);
	};

	handleChangeStatus = async (key) => {
		if (key === null) {
			this.setState({
				prevStatus: this.state.currStatus,
				showCustomDate: true,
				currStatus: key,
			});
		} else {
			this.setState(
				{
					currStatus: key,
					currentViewPage: 1,
					shootList: [],
					isPageLoading: true,
					backwardPage: 0,
					hasMorePast: true,
				},
				() => this.fetchMoreShoots(),
			);
		}
	};

	handleclearSelection = (e, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: [],
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
				backwardPage: 0,
				hasMorePast: true,
				...(type === 'workspace' ? { workspaceFilterCleared: true } : {}),
			},
			() => {
				this.fetchMoreShoots();
			},
		);
	};

	showShootAddEditModal = (eventDetails, shootEditType) => {
		this.setState({
			//showShootAddEditModal: eventDetails.id !== this.state.eventDetails.id ? true : false,
			showShootAddEditModal: !this.state.showShootAddEditModal,
			eventDetails: eventDetails,
			shootEditType,
		});
	};

	shootDetailsUpdated = async (event) => {
		let index = _.findIndex(this.state.shootList, {
			id: this.state.eventDetails.id,
		});
		let shootList = _.cloneDeep(this.state.shootList);
		shootList[index] = {
			...this.state.shootList[index],
			..._.pick(event, [
				'venue',
				'time',
				'slNo',
				'reportingTime',
				'parentEventName',
				'parentEvent_id',
				'outStation',
				'name',
				'id',
				'date',
				'city',
				'crewNew',
				'feedBack',
				'childEvents',
				'additionalServices',
			]),
			crewDetails: [],
		};

		_.map(event.crewNew, (crew, key) => {
			if (crew.isCustomUser !== true) {
				_.forEach(crew.roles, (roles) => {
					let found = undefined;
					found = _.find(this.state.tenantUsersList, { key: crew.userId });
					let data = {
						id: crew.userId,
						name:
							crew.userId === null
								? 'unassigned'
								: `${_.has(found, 'name') && found.name ? found.name : ''}`,
						dateOverlap: _.find(shootList[index].dateOverlap, (value, key) => {
							return value === crew.userId;
						})
							? true
							: false,
						dateTimeOverlap: _.find(shootList[index].dateTimeOverlap, (value, key) => {
							return value === crew.userId;
						})
							? true
							: false,
						isManager:
							crew.userId === null
								? false
								: crew.isManager === null
								? false
								: crew.isManager,
						role: roles.role,
						subRole: roles.subRole,
						displayName:
							crew.userId === null
								? 'unassigned'
								: `${
										_.has(found, 'displayName') && found.displayName !== ''
											? found.displayName
											: ''
								  }`,
					};
					shootList[index].crewDetails.push(data);
				});
			}
		});
		this.setState({ shootList }, () => this.flagShootersForTheSameDay());
	};
	toggleCreateShoot = async (e) => {
		this.setState({
			showCreateShootModal: true,
		});
	};
	handleCreateShootSelect = async (e, type) => {
		this.setState({
			[`createShoot${type}`]: e.value,
			[`createShoot${type}Name`]: e.label,
		});
		if (type === 'Workspace') {
			this.setState({
				isProjectsLoading: true,
			});
			await this.getVendorProjects(getProjects, {
				workspaceIds: e.label,
				filters: {
					limit: 100,
					page: 1,
				},
			});
		}
	};
	handleCreateShoot = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.state.createShootWorkspaceName}/${this.state.createShootProject}`,
		);
	};
	handleCUstomDateSelection = () => {
		if (this.state.startDate === null || this.state.endDate === null) {
			alert("You haven't chosen any date");
		} else {
			let mydate = !this.state.startDate
				? 'no start date is selected'
				: moment(this.state.startDate).format('YYYYMMDD');

			let myDate2 = !this.state.endDate
				? 'no end date is selected'
				: moment(this.state.endDate).format('YYYYMMDD');
			//his.props.params.vendorID
			// let json = {
			//     filters: {
			//         page: this.state.page,
			//         limit: this.state.limit,
			//         startDate: parseInt(mydate),
			//         endDate: parseInt(myDate2),
			//         subFilter: null,
			//     },
			//     vendorId: this.props.params.vendorID,
			// }
			// this.getVendorEventsList(getVendorEventsList, json)
			this.setState(
				{
					startDateVal: parseInt(mydate),
					endDateVal: parseInt(myDate2),
					isLoading: false,
					shootList: [],
					backwardPage: 0,
					hasMorePast: true,
				},
				() => this.fetchMoreShoots(),
			);
		}
	};
	onChange = (dates) => {
		const [start, end] = dates;
		this.setState({
			startDate: start,
			endDate: end,
		});
	};

	showNotifyTeamMemberModal = (tenantId, projectId, eventId) => {
		let shootList = _.cloneDeep(this.state.shootList);
		let eventDetails = _.filter(shootList, {
			id: eventId,
		})[0];

		let crewDetails = [];
		_.forEach(eventDetails.crewDetails, (crew, inx) => {
			if (crew.id !== null) {
				crewDetails.push(crew);
			}
		});

		eventDetails.crewDetails = crewDetails;

		this.setState({
			showNotifyTeamMemberModal: !this.state.showNotifyTeamMemberModal,
			notifyDetails: {
				tenantId,
				projectId,
				eventId,
				eventDetails,
			},
		});
	};

	notifyTeamMembers = (payload) => {
		let json = {
			workspaceId: _.find(this.state.workspacesFilters, {
				key: payload.tenantId,
			})?.name,
			projectId: payload.projectId,
			eventId: payload.eventId,
			crewPhNumber: payload.crewPhNumber,
		};
		this.whatsAppNotifyTeamMembers(notifyTeamMembers, json);
	};

	// renderShootTableBody = () => {
	// 	let dayCounter = 1;
	// 	const sortedShootList = _.sortBy(this.state.shootList, (shoot) => [
	// 		moment(shoot.date, 'YYYYMMDD').toDate(),
	// 		moment(shoot.reportingTime, 'HH:mm A').toDate(),
	// 	]);
	// 	return _.map(sortedShootList, (shoot, index) => {
	// 		let previousDay = 0;
	// 		let currentDay = 0;
	// 		if (index !== 0) {
	// 			previousDay = moment(sortedShootList[index - 1].date, 'YYYYMMDD').format('DD');
	// 			currentDay = moment(shoot.date, 'YYYYMMDD').format('DD');
	// 		}

	// 		if (currentDay != previousDay) dayCounter = dayCounter + 1;

	// 		let photoHeads = [];
	// 		let videoHeads = [];

	// 		_.map(shoot.collaborators, (collab) => {
	// 			if (_.indexOf(collab.designations, 'photographer') >= 0) {
	// 				let user = _.filter(this.state.tenantUsersList, {
	// 					key: collab.tenantUserId,
	// 				})[0];
	// 				if (_.has(user, 'name')) photoHeads.push(user.name);
	// 			}
	// 			if (_.indexOf(collab.designations, 'videographer') >= 0) {
	// 				let user = _.filter(this.state.tenantUsersList, {
	// 					key: collab.tenantUserId,
	// 				})[0];
	// 				if (_.has(user, 'name')) videoHeads.push(user.name);
	// 			}
	// 		});
	// 		return (
	// 			<>
	// 				{/* <thead>

	// 				</thead> */}
	// 				{currentDay != previousDay || currentDay === 0 ? (
	// 					<tr style={{ position: 'sticky', top: '30px' }}>
	// 						{this.state.columns.map((el, idx) => {
	// 							return (
	// 								<td
	// 									className="emptyCell"
	// 									style={{
	// 										textAlign: 'center',
	// 										color: 'white',
	// 										// position: 'sticky',
	// 										// top: '0',
	// 									}}
	// 								>
	// 									{idx === 0
	// 										? moment(shoot.date, 'YYYYMMDD').format('DD MMM')
	// 										: ''}
	// 								</td>
	// 							);
	// 						})}
	// 					</tr>
	// 				) : (
	// 					<></>
	// 				)}

	// 				<ShootsListTableRow
	// 					columns={this.state.columns}
	// 					key={shoot.id}
	// 					data={{
	// 						...shoot,
	// 					}}
	// 					handleShootClick={(e, newTab) =>
	// 						this.goToShoot(e, shoot.tenantId, shoot.projectId, shoot.id, newTab)
	// 					}
	// 					associatedTenants={this.state.associatedTenants}
	// 					onFlagSelected={this.onFlagSelected}
	// 					handleCrewClick={(type) => this.showShootAddEditModal(shoot, type)}
	// 					handleEquipmentClick={(type) =>
	// 						this.goToAssignReceiveEquipment(
	// 							shoot.tenantId,
	// 							shoot.projectId,
	// 							shoot.id,
	// 							type,
	// 						)
	// 					}
	// 					handleMCClick={(type) =>
	// 						this.goToAssignReceiveMC(
	// 							shoot.tenantId,
	// 							shoot.projectId,
	// 							shoot.id,
	// 							type,
	// 						)
	// 					}
	// 					onCityClick={(e, type) =>
	// 						this.setState(
	// 							{
	// 								cityActiveFilter: type,
	// 								searchType: 'city',
	// 							},
	// 							() => {
	// 								this.searchString(e, 'paste');
	// 							},
	// 						)
	// 					}
	// 					onProjectClick={(e, type) =>
	// 						this.setState(
	// 							{
	// 								projectTitleActiveFilter: type,
	// 								searchType: 'projectTitle',
	// 							},
	// 							() => {
	// 								this.searchString(e, 'paste');
	// 							},
	// 						)
	// 					}
	// 					photoHeads={photoHeads}
	// 					videoHeads={videoHeads}
	// 					copyCrew={(crew) => this.copyCrewFromEvent(crew)}
	// 					pasteCrew={this.pasteCrewToEvent}
	// 					isCrewCopied={this.state.isCrewCopied}
	// 					notifyTeamMembers={this.showNotifyTeamMemberModal}
	// 				/>
	// 			</>
	// 		);
	// 	});
	// };
	renderShootTableBody = () => {
		let dayCounter = 1;

		// Sort shootList within each date group by reporting time in ascending order
		// const sortedShootList = _.mapValues(_.groupBy(this.state.shootList, 'date'), (shoots) =>
		// 	_.sortBy(shoots, (shoot) => moment(shoot.reportingTime, 'HH:mm A').toDate()),
		// );
		const sortedShootList = _.mapValues(_.groupBy(this.state.shootList, 'date'), (shoots) => {
			const sortedShoots = _.sortBy(shoots, (shoot) =>
				moment(shoot.reportingTime, 'HH:mm A').toDate(),
			);
			const nullReportingTimeShoots = _.filter(sortedShoots, (shoot) => !shoot.reportingTime);
			const nonNullReportingTimeShoots = _.filter(
				sortedShoots,
				(shoot) => shoot.reportingTime,
			);
			return _.concat(nonNullReportingTimeShoots, nullReportingTimeShoots);
		});

		const reversedDates =
			(this.state.currStatus === null &&
				this.state.startDate === null &&
				this.state.endDate === null) ||
			this.state.currStatus === 'upcoming' ||
			this.state.currStatus === 'all'
				? _.keys(sortedShootList)
				: _.keys(sortedShootList).reverse();

		let previousDate = null;

		return _.flatMap(reversedDates, (date) => {
			const currentDate = moment(date, 'YYYYMMDD').format('DD MMM');
			// Check if the current date is different from the previous date
			const isNewDate = currentDate !== previousDate;
			previousDate = currentDate;

			const shoots = sortedShootList[date];
			let rows = [];
			_.forEach(shoots, (shoot) => {
				let photoHeads = [];
				let videoHeads = [];

				_.forEach(shoot.collaborators, (collab) => {
					if (_.indexOf(collab.designations, 'photographer') >= 0) {
						let user = _.filter(this.state.tenantUsersList, {
							key: collab.tenantUserId,
						})[0];
						if (_.has(user, 'name')) photoHeads.push(user.name);
					}
					if (_.indexOf(collab.designations, 'videographer') >= 0) {
						let user = _.filter(this.state.tenantUsersList, {
							key: collab.tenantUserId,
						})[0];
						if (_.has(user, 'name')) videoHeads.push(user.name);
					}
				});

				rows.push(
					<ShootsListTableRow
						columns={this.state.columns}
						key={shoot.id}
						data={{ ...shoot }}
						handleShootClick={(e, newTab) =>
							this.goToShoot(e, shoot.tenantId, shoot.projectId, shoot.id, newTab)
						}
						handleSingleCrewRemove={this.handleSingleCrewRemove}
						associatedTenants={this.state.associatedTenants}
						onFlagSelected={this.onFlagSelected}
						handleCrewClick={(type) => this.showShootAddEditModal(shoot, type)}
						handleEquipmentClick={(type) =>
							this.goToAssignReceiveEquipment(
								shoot.tenantId,
								shoot.projectId,
								shoot.id,
								type,
							)
						}
						handleMCClick={(type) =>
							this.goToAssignReceiveMC(
								shoot.tenantId,
								shoot.projectId,
								shoot.id,
								type,
							)
						}
						onCityClick={(e, type) =>
							this.setState(
								{
									cityActiveFilter: type,
									searchType: 'city',
								},
								() => {
									this.searchString(e, 'paste');
								},
							)
						}
						onProjectClick={(e, type) =>
							this.setState(
								{
									projectTitleActiveFilter: type,
									searchType: 'projectTitle',
								},
								() => {
									this.searchString(e, 'paste');
								},
							)
						}
						photoHeads={photoHeads}
						videoHeads={videoHeads}
						copyCrew={(crew) => this.copyCrewFromEvent(crew)}
						pasteCrew={this.pasteCrewToEvent}
						isCrewCopied={this.state.isCrewCopied}
						notifyTeamMembers={this.showNotifyTeamMemberModal}
					/>,
				);
			});

			return [
				// Render date row when it's a new date
				isNewDate && (
					<tr style={{ position: 'sticky', top: '30px' }}>
						{this.state.columns.map((el, idx) => (
							<td
								className="emptyCell"
								style={{
									textAlign: 'center',
									color: 'white',
								}}
								key={idx}
							>
								{idx === 0 ? currentDate : ''}
							</td>
						))}
					</tr>
				),
				// Render the rows for each shoot
				...rows,
			];
		});
	};

	copyCrewFromEvent = (crew) => {
		this.setState({
			copiedCrew: crew,
			isCrewCopied: true,
		});
	};

	pasteCrewToEvent = async (tenantId, projectId, eventId, copyToEventCrew) => {
		let duplicateCrewWithRole = _.filter(this.state.copiedCrew, (crewTemp, inx) => {
			let found = undefined;
			found = _.find(copyToEventCrew, {
				id: crewTemp.id,
				role: crewTemp.role,
				subRole: crewTemp.subRole,
			});
			if (found) {
				return true;
			} else {
				return false;
			}
		});

		if (_.size(duplicateCrewWithRole) > 0) {
			this.setState({
				showDuplicateCrewWithRoleWarning: true,
				duplicateCrewWithRole: duplicateCrewWithRole,
			});
		} else {
			let copyCrew = [];
			_.forEach([...this.state.copiedCrew, ...copyToEventCrew], (crew, index) => {
				let foundIndex = -1;
				foundIndex = _.findIndex(copyCrew, {
					userId: crew.id,
				});
				if (foundIndex !== -1) {
					copyCrew[foundIndex].roles.push({
						role: crew.role,
						subRole: crew.subRole,
					});
					copyCrew[foundIndex].isManager =
						copyCrew[foundIndex].isManager === true ? true : crew.isManager;
				} else {
					copyCrew.push({
						roles: [{ role: crew.role, subRole: crew.subRole }],
						userId: crew.id,
						isManager: crew.isManager,
					});
				}
			});

			let json = {
				projectId,
				eventId,
				eventInput: {
					crewNew: copyCrew,
				},
				workspaceId: _.find(this.state.workspacesFilters, {
					key: tenantId,
				})?.name,
			};

			this.setState({
				eventDetails: { id: eventId },
			});

			await this.putShoot(updateShoot, json);

			this.setState({
				isCrewCopied: false,
				copiedCrew: [],
			});
		}
	};

	applyFilter = (filter, type) => {
		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				shootList: [],
				isPageLoading: true,
				backwardPage: 0,
				hasMorePast: true,
				...(type === 'workspace' ? { workspaceFilterCleared: false } : {}),
			},
			() => {
				this.fetchMoreShoots();
			},
		);
	};

	handleSingleCrewRemove = async (event, index, rolesIndex) => {
		let crewNew = _.cloneDeep(event.crewNew);
		crewNew[index].roles.splice(rolesIndex, 1);
		if (_.size(crewNew[index].roles) === 0) {
			crewNew.splice(index, 1);
		}

		crewNew = _.map(crewNew, (cr, inx) => {
			let newCr = _.omit(cr, ['__typename', 'isCustomUser']);
			newCr.roles = _.map(newCr.roles, (roles, indx) => {
				return _.omit(roles, ['__typename']);
			});
			return newCr;
		});
		let json = {
			projectId: event.projectId,
			eventId: event.id,
			eventInput: {
				crewNew: crewNew,
			},
			workspaceId: _.find(this.state.workspacesFilters, {
				key: event.tenantId,
			})?.name,
		};

		this.setState({
			eventDetails: {
				id: event.id,
			},
		});

		await this.putShoot(updateShoot, json);
	};

	render() {
		if (this.state.isLoading == false && localStorage.getItem('lastViewedShootID')) {
			setInterval(function () {
				const element = document.getElementById(localStorage.getItem('lastViewedShootID'));

				if (element) {
					element.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
					localStorage.removeItem('lastViewedShootID');
				}
			}, 1000);
		}
		return (
			<div className="layout-wrapper">
				{this.state.isLoading === true ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						<div className="searchContainer">
							<div className="shoots-header-filters-container">
								<div
									className="workspace-drop-down-btn"
									ref={this.workspacewrapper}
									onClick={(e) => this.toggleWorkspaceDropDown(e)}
								>
									<span className="drop-dwn-text">
										{
											_.find(this.state.statusFilters, {
												key: this.state.currStatus,
											})?.name
										}
									</span>
									<span
										className={
											'drop-dwn-icn' +
											(this.state.showWorkspaceDropDown === true
												? ' opened'
												: '')
										}
									>
										<DownIcon />
									</span>
									{this.state.showWorkspaceDropDown ? (
										<div
											className="search-dropdown"
											ref={this.workspaceDropDownRef}
										>
											{_.map(this.state.statusFilters, (item, index) => {
												return (
													<a
														className={`item ${
															item.key === this.state.currStatus
																? 'active'
																: ''
														}`}
														onClick={() =>
															this.handleChangeStatus(item.key)
														}
													>
														{item.name}
													</a>
												);
											})}
										</div>
									) : (
										''
									)}
								</div>
								<Filter
									type={'workspace'}
									label={'Workspaces'}
									version="v2"
									filters={this.state.workspacesFilters}
									activeFilter={this.state.workspaceActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'workspace', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'workspace')
									}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'shooters'}
									label={'Shooter'}
									version="v2"
									filters={this.state.tenantUsersList}
									activeFilter={this.state.shootersActiveFilter}
									handleActiveFilter={(e, type, key) => {
										this.handleActiveFilter(e, 'shooters', key);
									}}
									clearSelection={(e) => {
										this.handleclearSelection(e, 'shooters');
									}}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								<Filter
									type={'city'}
									label={'City'}
									version="v2"
									filters={this.state.cityFilters}
									activeFilter={this.state.cityActiveFilter}
									onOpen={this.handleCityFilterOpen}
									loading={this.state.isCityListLoading}
									handleActiveFilter={(e, type, key) => {
										this.handleActiveFilter(e, 'city', key);
									}}
									clearSelection={(e) => {
										this.handleclearSelection(e, 'city');
									}}
									isMultipleSelectable={true}
									filterType="shoot"
									applyFilter={this.applyFilter}
								/>
								{this.state.showCustomDate ? (
									<>
										<div className="datePicker">
											<div className="dp-container">
												<DatePicker
													// inline
													placeholderText={
														moment(new Date()).format('DD/MM/YYYY') +
														' - All Time'
													}
													ref={this.calRef}
													selected={
														this.state.startDate
															? this.state.startDate
															: new Date()
													}
													shouldCloseOnSelect={false}
													onChange={this.onChange}
													startDate={this.state.startDate}
													endDate={this.state.endDate}
													selectsRange
													dayClassName={() =>
														'example-datepicker-day-class'
													}
													popperClassName="example-datepicker-class"
													// todayButton="TODAY"
													// onChange={(date) => {
													//     this.setState({
													//         startDate: date,
													//     })
													// }}
												>
													{' '}
													<div
														className=""
														style={{
															marginLeft: '80px',
														}}
													>
														<button
															style={{
																marginLeft: '10px',
																cursor: 'pointer',
																backgroundColor: '#F5F5F5',
																borderRadius: '4px',
																// color: 'white',
																border: 'none',
																padding: '6px 8px',
															}}
															onClick={() => {
																this.calRef.current.setOpen(false);
																this.setState({
																	showCustomDate: false,
																	currStatus:
																		this.state.prevStatus,
																});
															}}
														>
															Cancel
														</button>
														<button
															style={{
																marginLeft: '10px',
																cursor: 'pointer',
																backgroundColor: '#2153CC',
																borderRadius: '4px',
																color: 'white',
																border: 'none',
																padding: '6px 8px',
															}}
															onClick={() => {
																this.calRef.current.setOpen(false);
																this.handleCUstomDateSelection();
															}}
														>
															Apply
														</button>
													</div>
												</DatePicker>
											</div>
											{/* <div className="dp-container">
                                                <DatePicker
                                                    ref={this.calRef2}
                                                    selected={
                                                        this.state.endDate
                                                            ? this.state.endDate
                                                            : new Date()
                                                    }
                                                    onChange={(date) => {
                                                        this.setState({
                                                            endDate: date,
                                                        })
                                                    }}
                                                >
                                                    <div
                                                        className=""
                                                        style={{
                                                            marginLeft: '80px',
                                                        }}
                                                    >
                                                        <button
                                                            style={{
                                                                marginLeft:
                                                                    '10px',
                                                                cursor: 'pointer',
                                                                backgroundColor:
                                                                    '#F5F5F5',
                                                                borderRadius:
                                                                    '4px',
                                                                // color: 'white',
                                                                border: 'none',
                                                                padding:
                                                                    '6px 8px',
                                                            }}
                                                            onClick={() => {
                                                                this.calRef2.current.setOpen(
                                                                    false
                                                                )
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            style={{
                                                                marginLeft:
                                                                    '10px',
                                                                cursor: 'pointer',
                                                                backgroundColor:
                                                                    '#2153CC',
                                                                borderRadius:
                                                                    '4px',
                                                                color: 'white',
                                                                border: 'none',
                                                                padding:
                                                                    '6px 8px',
                                                            }}
                                                            onClick={() => {
                                                                this.calRef2.current.setOpen(
                                                                    false
                                                                )
                                                            }}
                                                        >
                                                            Apply
                                                        </button>
                                                    </div>
                                                </DatePicker>
                                            </div> */}
										</div>

										{/* <button
                                            onClick={() =>
                                                this.handleCUstomDateSelection()
                                            }
                                        >
                                            Show list
                                        </button> */}
									</>
								) : (
									<></>
								)}
							</div>

							{/* <div
								className={
									'searchWrapper with-focus' +
									(_.size(this.state.projectTitleActiveFilter) > 0
										? ' active'
										: '')
								}
							>
								<div className="search-inner-left">
									<input
										placeholder="Search Client"
										name={'projectTitle'}
										value={this.state.projectTitleActiveFilter}
										onChange={(e) => this.searchString(e)}
									/>
								</div>
								<div className="search-inner-right">
									<span
										className="search-dropdown-btn"
										style={{ position: 'relative' }}
									>
										<a className="search-type">Search</a>
									</span>
								</div>
							</div> */}
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									gap: '10px',
								}}
							>
								<div className="searchWrapper">
									<div className="search-inner-left">
										<span className="search-icon">
											<SearchIcon />
										</span>
										<input
											placeholder="Search"
											name={this.state.searchType}
											value={
												this.state[`${this.state.searchType}ActiveFilter`]
											}
											onChange={(e) => this.searchString(e)}
										/>
									</div>
									<div className="search-inner-right">
										<span className="in-text">by</span>
										<span
											className="search-dropdown-btn"
											//style={{ position: 'relative' }}
										>
											<a
												className="search-type"
												onClick={(e) => this.toggleSearchDropDown(e)}
												ref={this.wrapper}
											>
												Client
												{/* <b
													className={
														this.state.showSearchDropDown
															? 'invert'
															: ''
													}
												>
													<DownIcon />
												</b> */}
											</a>
											{/* {this.state.showSearchDropDown ? (
												<div
													className="search-dropdown right-zero search-type"
													ref={this.searchDropDownRef}
												>
													<a
														className={`item ${
															this.state.searchType === 'projectTitle'
																? 'active'
																: ''
														}`}
														onClick={(e) =>
															this.toggleSearchType(e, 'projectTitle')
														}
													>
														Client
													</a>
													<a
														className={`item ${
															this.state.searchType === 'city'
																? 'active'
																: ''
														}`}
														onClick={(e) =>
															this.toggleSearchType(e, 'city')
														}
													>
														City
													</a>
												</div>
											) : (
												''
											)} */}
										</span>
									</div>
								</div>
								<div
									className="create-shoot-btn"
									onClick={(e) => this.toggleCreateShoot(e)}
								>
									+ Create Shoot
								</div>
							</div>
						</div>

						<div
							className={'table shoots-table'}
							id={'scrollableDiv-shoots-vendors'}
							ref={this.scrollContainerRef}
							onWheel={this.handleShootsWheel}
							style={{
								height: 'calc(100vh - 95.97px)',
								overflowY: 'auto',
								position: 'relative',
							}}
						>
							{this.state.loadingPast && (
								<div
									style={{
										position: 'absolute',
										top: 0,
										left: 0,
										right: 0,
										zIndex: 10,
										color: '#fff',
										textAlign: 'center',
										padding: '8px 0',
										fontSize: '13px',
										backgroundColor: 'rgba(0, 0, 0, 0.6)',
									}}
								>
									Loading past shoots...
								</div>
							)}
							{this.state.isPageLoading === true ? (
								<LoadingBar />
							) : (
								<div className="projects-table-outer-container">
										<InfiniteScroll
										dataLength={this.state.lengthOfList}
										next={() => {
											this.onClickNextPage();
										}}
										hasMore={this.state.hasNextPage}
										loader={
											<div
												style={{
													color: '#fff',
													textAlign: 'center',
													width: '100%',
													padding: '20px',
												}}
											>
												Loading...
											</div>
										}
										scrollableTarget={'scrollableDiv-shoots-vendors'}
										scrollThreshold={0.5}
									>
										<table className="shootTable">
											<thead>
												<tr height={48}>
													{_.map(this.state.columns, (column, key) => {
														return (
															<th
																className={
																	_.has(column, 'className')
																		? column.className
																		: 'all-other-column-fixed'
																}
															>
																<div className="th-header">
																	{_.has(column, 'dummyPad') ? (
																		<span
																			className="dummy-pad"
																			style={{
																				minWidth:
																					_.has(
																						column,
																						'dummyPad',
																					) &&
																					_.has(
																						column,
																						'dummyPadWidth',
																					)
																						? column.dummyPadWidth
																						: '',
																			}}
																		></span>
																	) : (
																		''
																	)}
																	<p className="header-title">
																		{column.title}{' '}
																		{_.has(
																			column,
																			'lineBreakTitle',
																		) ? (
																			<>
																				{' '}
																				<br />{' '}
																				{
																					column.lineBreakTitle
																				}
																			</>
																		) : (
																			''
																		)}
																	</p>
																	{_.has(column, 'sortBy') ? (
																		<span
																			className={
																				'sort-icn' +
																				(this.state[
																					`${column.sortBy}SortType`
																				] == -1
																					? ' sort-visible'
																					: this.state[
																							`${column.sortBy}SortType`
																					  ] == 1
																					? ' sort-visible sort-ascending'
																					: ' sort-hidden')
																			}
																		>
																			<Down />
																		</span>
																	) : (
																		''
																	)}
																</div>
															</th>
														);
													})}
												</tr>
											</thead>

											<tbody>{this.renderShootTableBody()}</tbody>
										</table>
									</InfiniteScroll>
								</div>
							)}
						</div>
						{this.state.showShootAddEditModal === true ? (
							<CreateShoot
								key={this.state.eventDetails.id}
								handleClose={() =>
									this.setState({
										showShootAddEditModal: false,
										shootEditType: null,
									})
								}
								show={this.state.showShootAddEditModal}
								close={() =>
									this.setState({
										showShootAddEditModal: false,
										shootEditType: null,
									})
								}
								data={this.state.eventDetails}
								activeShootID={this.state.eventDetails.id}
								projectTitle={this.state.eventDetails.projectTitle}
								tenantId={this.state.eventDetails.tenantId}
								tenantUsersList={this.state.tenantUsersList}
								shootDetailsUpdated={(event) => this.shootDetailsUpdated(event)}
								additionalServicesUpdated={() => {
									this.setState({
										isPageLoading: true,
										lengthOfList: 0,
										shootList: [],
										backwardPage: 0,
										hasMorePast: true,
									});
									this.getVendorShootListData();
								}}
								projectId={this.state.eventDetails.projectId}
								isTenantCreate={false} //this.state.selectedProjectID === null}
								workspaceID={
									_.find(this.state.workspacesFilters, {
										key: this.state.eventDetails.tenantId,
									})?.name
								}
								custClass={'modal-with-no-fixed-height'}
								displayOnly={this.state.shootEditType}
							/>
						) : null}
					</div>
				)}
				{this.state.showNotifyTeamMemberModal ? (
					<NotifyShootCrew
						close={() => this.setState({ showNotifyTeamMemberModal: false })}
						handleClose={() => this.setState({ showNotifyTeamMemberModal: false })}
						show={this.state.showNotifyTeamMemberModal}
						notifyDetails={this.state.notifyDetails}
						tenantUsersList={this.state.tenantUsersList}
						notifyCrew={this.notifyTeamMembers}
					/>
				) : null}
				<Modal
					handleClose={() =>
						this.setState({
							showCreateShootModal: false,
						})
					}
					show={this.state.showCreateShootModal}
					modalType={'center'}
					isOverflowVisible={true}
				>
					<div className="busy-modal">
						<div className="bm-header">Create New Shoot</div>
						<div className="bm-body">
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<div
									className="floating-select-container"
									style={{
										display: 'block',
										float: 'left',
										margin: '30px 0px',
										zIndex: 2,
									}}
								>
									<label>Workspace*</label>
									<Select
										className="cost-select-container w-100p fixed-select-container"
										classNamePrefix="cost-select"
										options={this.state.workspacesOptions}
										onChange={(e) =>
											this.handleCreateShootSelect(e, 'Workspace')
										}
										defaultValue={
											_.filter(this.state.workspacesOptions, {
												value: this.state.createShootWorkspace,
											})[0]
										}
										isSearchable={true}
									/>
								</div>
								{this.state.isPageLoading == false ? (
									this.state.createShootWorkspace == null ? (
										''
									) : (
										<div
											className="floating-select-container"
											style={{
												display: 'block',
												float: 'left',
												margin: '50px 0px',
												zIndex: 1,
											}}
										>
											<label>Project*</label>
											<Select
												className="cost-select-container w-100p fixed-select-container"
												classNamePrefix="cost-select"
												options={this.state.projectsOptions}
												onChange={(e) =>
													this.handleCreateShootSelect(e, 'Project')
												}
												defaultValue={
													_.filter(this.state.projectsOptions, {
														value: this.state.createShootProject,
													})[0]
												}
												isSearchable={true}
											/>
										</div>
									)
								) : (
									<LoadingBar />
								)}
							</div>
						</div>
						{this.state.createShootWorkspace !== null &&
						this.state.createShootProject !== null ? (
							<div className="bm-footer">
								<a
									onClick={(e) => this.handleCreateShoot(e)}
									style={{
										margin: '0px 15px',
										background:
											'linear-gradient(90deg, #9256D9 0%, #5F55EC 100%)',
										color: '#fff',
									}}
								>
									Proceed
								</a>
							</div>
						) : (
							''
						)}
					</div>
				</Modal>
				{this.state.showDuplicateCrewWithRoleWarning === false ? null : (
					<Modal
						handleClose={() =>
							this.setState({
								showDuplicateCrewWithRoleWarning: false,
								duplicateCrewWithRole: [],
								copiedCrew: [],
								isCrewCopied: false,
							})
						}
						show={this.state.showDuplicateCrewWithRoleWarning}
						modalType={'center'}
					>
						<div className="busy-modal">
							<div className="bm-header">COPY ERROR</div>
							<div className="bm-body">
								<span>
									{_.map(this.state.duplicateCrewWithRole, (dup, inx) => {
										return (
											<div>
												{`${inx + 1}. ${
													dup.name
												} (${dup.subRole[0].toUpperCase()}${
													dup.role === 'cinematographer'
														? 'V'
														: dup.role[0].toUpperCase()
												})`}
											</div>
										);
									})}
								</span>
								<p>Crew already exists with same role and sub role.</p>
							</div>
							<div className="bm-footer">
								<a
									onClick={() =>
										this.setState({
											showDuplicateCrewWithRoleWarning: false,
											duplicateCrewWithRole: [],
											copiedCrew: [],
											isCrewCopied: false,
										})
									}
								>
									Okay, Got it
								</a>
							</div>
						</div>
					</Modal>
				)}
			</div>
		);
	}
}

export default withRouter(Shoots);
